import React, { Component } from 'react';
import { connect } from 'react-redux';
import GeminiScrollbar from 'react-gemini-scrollbar';
import 'gemini-scrollbar/gemini-scrollbar.css'
import {
  fetchWidget
} from '../../store/actions/widget-actions';
import { isMobileOnly } from "react-device-detect";

import Slider from "react-slick";


import './style.scss';

class WidgetChannel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSlide: 0,
      descriptionVisibility: false,
    };
  };

  componentDidMount() {
    const { widgetChannel } = this.props;
    this.props.fetchWidget(widgetChannel);
  }

  toggleDescription = () => {
    this.setState({
      descriptionVisibility: !this.state.descriptionVisibility,
    });
  }
  render() {
    const carouselSettings = {
      dots: false,
      infinite: false,
      autoplay: false,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      beforeChange: (oldIndex, newIndex) => {
        this.setState({
          activeSlide: newIndex
        });
      },
      responsive: isMobileOnly ? [

        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3
          }
        },

      ]

        : [
          {
            breakpoint: 499,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 399,
            settings: {
              slidesToShow: 3
            }
          }
        ]

    };

    if (!this.props.widget.data) {
      return null;
    }
    const {
      activeSlide,
      descriptionVisibility,
    } = this.state;
    const {
      isLogged,
      isVisible,
      isWidgetBooks,
      isWidgetSubs,
      coverLink,
      widget: { data: { channel, baseUrl } }
    } = this.props;
    let backgroundLink;
    if (channel.books) {
      backgroundLink = `${baseUrl}${channel.books[activeSlide].cover || coverLink}`;
    } else {
      backgroundLink = coverLink
    }
    const style = { backgroundImage: `url(${backgroundLink})` };

    return (
      <div className={`widget-channel ${isVisible || channel ? '' : 'hidden'} `}>
        <div style={style} className="widget-channel__image-overlay" />
        <div className="widget-channel__color-overlay" />

        <div className="widget-channel__body">
          <div className="widget-channel__header">
            <div className="widget-channel__avatar">
              <a href={`${baseUrl}/channels/${channel.slug}`} target="_blank">
                <img src={`${baseUrl}${channel.image}`} height="100" alt="" />
              </a>
            </div>
            <h2 className="widget-channel__title">
              <a href={`${baseUrl}/channels/${channel.slug}`} target="_blank">
                {channel.name}
              </a>
            </h2>
            <div className="widget-channel__description">
              <p dangerouslySetInnerHTML={{ __html: channel.description }} />
              <div
                className="widget-channel__link"
                onClick={this.toggleDescription}
              >
                Read more
              </div>

            </div>

            <div className="widget-channel__subscribers subscribe-viewer-counter">
              {isWidgetSubs &&
                <span className="subscribe-viewer-counter__title">
                  {channel.numberOfSubscribers}
                </span>
              }
              <a
                className="subscribe-viewer-counter__button [ cb-btn-viewer cb-btn-viewer--light cb-btn-viewer--sm ]"
                href={`${baseUrl}/channels/${channel.slug}`}
                target="_blank"
              >
                CHANNEL PAGE
              </a>
            </div>
          </div>

          {isWidgetBooks && channel.books &&
            <Slider {...carouselSettings} className="widget-carousel">
              {channel.books.map((item, index) => (
                <a href={`${baseUrl}${item.slug}`} target="_blank" key={index}>
                  <img src={`${baseUrl}${item.cover}`} alt={item.title} />
                </a>
              ))}
            </Slider>
          }

          {descriptionVisibility &&
            <div className="channel-description-modal-viewer">
              <div
                className="channel-description-modal-viewer__close"
                onClick={this.toggleDescription}
              />
              <div className="channel-description-modal-viewer__scroll">
                <GeminiScrollbar forceGemini>
                  <p className="channel-description-modal-viewer__text" dangerouslySetInnerHTML={{ __html: channel.description }} />
                </GeminiScrollbar>

              </div>

            </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ loginPopup, book, app, widget }) => {
  return {
    isVisible: loginPopup.isVisible,
    coverLink: book.cover_h.download_link,
    widgetChannel: app.widgetChannel,
    isLogged: book.isLogged,
    isWidget: app.isWidget,
    isWidgetBooks: app.isWidgetBooks,
    isWidgetSubs: app.isWidgetSubs,
    widget
  }
};

const actionCreators = {
  fetchWidget
}
export default connect(mapStateToProps, actionCreators)(WidgetChannel)


// WEBPACK FOOTER //
// ./src/containers/widget-channel/WidgetChannel.jsx